<template>
    <v-sheet rounded color="grey lighten-5" elevation="1" class="pa-4">
        <v-row>
            <v-col>
                <slot />
            </v-col>
        </v-row>

        <v-row v-if="sent">
            <v-col>
                <v-alert type="success">
                    <v-icon>mdi-email</v-icon>
                    Message Sent!
                </v-alert>
            </v-col>
        </v-row>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="submitForm"
        >
            <v-row>
                <v-col>
                    <text-field
                        v-model="form.name"
                        :rules="nameRules"
                        label="Name"
                        required
                        :error-messages="form.errors.name"
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="6">
                    <text-field
                        v-model="form.email"
                        :rules="emailRules"
                        label="Email"
                        required
                        :error-messages="form.errors.email"
                    />
                </v-col>

                <v-col cols="12" md="6">
                    <text-field
                        v-model="form.phone"
                        label="Phone"
                        type="number"
                        :error-messages="form.errors.phone"
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <textarea-field
                        v-model="form.message"
                        :rules="messageRules"
                        label="Message"
                        :hint="hint"
                        persistent-hint
                        required
                        :error-messages="form.errors.message"
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="6">
                    <v-btn
                        color="primary"
                        :disabled="form.processing"
                        :loading="form.processing"
                        type="submit"
                    >
                        Send
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <div class="text-caption">
                        By submitting this form, you acknowledge that we may use
                        your information provided above to contact you in
                        response to this request, and you agree with our
                        <a
                            target="_blank"
                            :href="$page.props.company_info.privacy_policy"
                            >Privacy Policy</a
                        >
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </v-sheet>
</template>

<script>
import TextField from "../Forms/TextField";
import TextareaField from "../Forms/TextareaField";
export default {
    name: "ContactForm",
    components: { TextareaField, TextField },
    props: {
        hint: {
            type: String,
            default: "",
        },

        message: {
            type: String,
            default: "",
        },

        origin: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                name: "",
                email: "",
                phone: "",
                message: this.message,
                origin: this.origin,
            }),
            valid: true,
            nameRules: [
                (v) => !!v || "Name is required",
                (v) =>
                    (v && v.length <= 255) ||
                    "Name must be less than 255 characters",
            ],
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            messageRules: [
                (v) => !!v || "Message is required",
                (v) =>
                    (v && v.length <= 255) ||
                    "Message must be less than 255 characters",
            ],
            sent: false,
        };
    },

    methods: {
        submitForm() {
            if (!this.$refs.form.validate()) {
                return;
            }

            this.form.post(this.route("contact.send"), {
                preserveScroll: true,
                onSuccess: () => {
                    this.sent = true;
                    this.form.reset();
                    this.$refs.form.resetValidation();
                },
            });
        },
    },
};
</script>

<style scoped></style>
